<script setup lang="ts">
import skoreLogo from "@/assets/images/skore-text.svg";

const { showLogo = true } = defineProps<{
  showLogo?: boolean;
}>();
</script>

<template>
  <div class="full-page-layout">
    <div class="content">
      <div v-if="showLogo" class="logo">
        <img :src="skoreLogo" alt="skore" />
      </div>
      <h3 class="text-lg-medium" v-if="$slots.title">
        <slot name="title"></slot>
      </h3>
      <div class="subtitle text-base-medium" v-if="$slots.subtitle">
        <slot name="subtitle"></slot>
      </div>
      <div class="main-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
.full-page-layout {
  --background-color: var(--color-brand-blue-100);

  width: 100dvw;
  height: 100dvh;
  background-color: var(--background-secondary);
  background-image:
    linear-gradient(
      to right,
      transparent,
      transparent 5px,
      var(--background-color) 5px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to right,
      transparent,
      transparent 5px,
      var(--background-color) 5px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to bottom,
      transparent,
      transparent 5px,
      var(--background-color) 5px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to bottom,
      transparent,
      transparent 5px,
      var(--background-color) 5px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to right,
      transparent,
      transparent 1px,
      var(--background-color) 1px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to right,
      transparent,
      transparent 1px,
      var(--background-color) 1px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to right,
      transparent,
      transparent 1px,
      var(--background-color) 1px,
      var(--background-color) 8px
    ),
    linear-gradient(
      to right,
      transparent,
      transparent 1px,
      var(--background-color) 1px,
      var(--background-color) 8px
    );
  background-position:
    0 60px,
    0 calc(100% - 60px),
    120px 2px,
    calc(100% - 120px) 2px,
    116px 56px,
    calc(100% - 117px) 56px,
    calc(100% - 117px) calc(100% - 57px),
    116px calc(100% - 57px);
  background-repeat:
    repeat no-repeat,
    repeat no-repeat,
    no-repeat repeat,
    no-repeat repeat,
    no-repeat no-repeat,
    no-repeat no-repeat,
    no-repeat no-repeat,
    no-repeat no-repeat;
  background-size:
    8px 1px,
    8px 1px,
    1px 8px,
    1px 8px,
    8px 8px,
    8px 8px,
    8px 8px,
    8px 8px;

  .content {
    display: flex;
    min-height: 100dvh;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .logo {
      margin-bottom: var(--numbers-8);
      text-align: center;

      img {
        display: inline-block;
        height: var(--numbers-40);
      }
    }

    .subtitle {
      color: var(--content-secondary);
    }

    .main-content {
      margin-top: var(--numbers-24);
    }
  }
}
</style>
